<template>
	<!-- Footer Start -->
	<footer class="footer" style="background-image: url(../images/footer-bg.png);">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="mb-4">
						<a href="/">
							<img src="../../../images/logo-light.png" alt="" class="logo-light" height="30" />
						</a>
					</div>
				</div>
				<div class="col-lg-12 ms-lg-auto">
					<div class="row">
						<div class="col-12">
							<div class="mt-4 mt-lg-0">
								<ul class="list-unstyled footer-sub-menu">
									<li><a href="javascript: void(0);" class="footer-link">상호명 : 마이파랑</a></li>
									<li><a href="javascript: void(0);" class="footer-link">대표 : 오한식</a></li>
									<li><a href="javascript: void(0);" class="footer-link">이메일 : myparang.io@gmail.com</a></li>
									<li><a href="javascript: void(0);" class="footer-link">사업장소재지 : 경기 안양시 동안구 엘에스로 142 B102호</a></li>
									<li><a href="javascript: void(0);" class="footer-link">통신판매업신고 : 제 2022-안양동안-0130 호</a></li>
									<li><a href="javascript: void(0);" class="footer-link">사업자등록번호 : 599-35-00633</a></li>
									<li><a href="javascript: void(0);" class="footer-link">Copyright ⓒ MyParang. All rights reserved</a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- Footer End -->
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/main/Footer.vue